module.exports = __webpack_public_path__ + "img/DE03942.6b00f4cb.png";